import axios from "axios";

export default {
  namespaced: true,
  state: {
    routes: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    routesMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    RECEIVED_ROUTES(state, payload) {
      state.routes = payload;
      state.isReceiving = false;
    },
    RECEIVING_ROUTES(state) {
      state.isReceiving = true;
    },
    RECEIVED_ROUTE(state, payload) {
      let find = state.routes.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { routes: [payload, ...state.routes] });
      }
      else {
        let index = state.routes.findIndex(x => x._id === payload._id);
        state.routes.splice(index, 1, payload);
      }
    },
    RECEIVING_ROUTE(state) {
      state.isReceiving = true;
    },
    UPDATED_ROUTE(state, payload) {
      let index = state.routes.findIndex(route => route._id === payload._id);
      state = Object.assign(state, {
        routes: state.routes.map((route, i) => {
          if (i === index) {
            return Object.assign({}, route, payload);
          }
          return route;
        }),
        isUpdating: false,
        routesMessage: 'Routes has been updating!',
      })
    },
    UPDATING_ROUTE(state) {
      state.isUpdating = true;
    },
    DELETED_ROUTE(state, payload) {
      let indexToDelete = state.routes.findIndex(route => route._id === payload._id);
      let routes = [...state.routes];
      routes.splice(indexToDelete, 1);
      state = Object.assign(state, {
        routes: [...routes],
        isDeleting: false,
        idToDelete: null,
        routesMessage: 'Route has been Deleted!',
      });
    },
    DELETING_ROUTE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    deleteRouteRequest({dispatch}, payload) {
      dispatch("deletingRoute", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/route/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "delete", url: url,headers: headers})
      .then(function (response) {
        dispatch("deleteRoute", response.data);
      })
      .catch(function (error) {
        console.log(error.data);
      });
    },
    async deleteRouteItemRequest({dispatch}, payload) {
      try{
        dispatch("deletingRoute", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/routeitem/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteRoute", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getRoutesRequest({dispatch}) {
      dispatch("receivingRoutes");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/routes';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: headers})
      .then(res => {
        dispatch("receiveRoutes", res.data);
      })
    },
    async getRoutesAllRequest({dispatch}) {
      dispatch("doNothing");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/routes/all';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "get",url: url, headers: headers});
      return response.data;
    },
      async getRouteDayRequest({dispatch}) {
      dispatch("doNothing");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/get/route-day';
      var headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "get",url: url, headers: headers});
      return response.data;
    },
    async getRouteRequest({dispatch}, id) {
      dispatch("receivingRoutes");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/route/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "get",url: url,headers: header});
      dispatch("receiveRoute", response.data);
      return response.data;
    },
    async insertRouteRequest({dispatch}, payload) {
      dispatch("receivingRoute");
      let  token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/route';
      let data = payload;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "post", url: url, headers: headers, data: data})
      .then((response)=> {
        dispatch("receiveRoute", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });	
    },
    async insertRouteItemRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/routeitem/' + payload.routeid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        console.log(response.data)
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    updateRouteRequest({dispatch}, payload) {
      dispatch("updatingRoute");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/route/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "put", url: url,headers: headers,data: payload})
      .then(function (response) {
        dispatch("updateRoute", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateRouteItemRequest({dispatch}, payload) {
      try{
        dispatch("doNothing");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/routeitem/' + payload.routeitemid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    receiveRoutes({commit}, payload) {
      commit("RECEIVED_ROUTES", payload)
    },
    receivingRoutes({commit}) {
      commit("RECEIVING_ROUTES")
    },
    receiveRoute({commit}, payload) {
      commit("RECEIVED_ROUTE", payload)
    },
    receivingRoute({commit}) {
      commit("RECEIVING_ROUTE")
    },
    updateRoute({commit}, payload) {
      commit("UPDATED_ROUTE", payload)
    },
    updatingRoute({commit}) {
      commit("UPDATING_ROUTE")
    },
    deleteRoute({commit}, payload) {
      commit("DELETED_ROUTE", payload)
    },
    deletingRoute({commit}, payload) {
      commit("DELETING_ROUTE", payload)
    }
  },
};
